import { POSTERS } from "./posters.generated";

/**
 * Public URL for a 9:16 poster (720x1280), or undefined when
 * public/posters/<slug>.webp is not in the build manifest.
 * `posters` defaults to that manifest; tests pass a fixture set.
 */
export function posterFor(slug: string, posters: ReadonlySet<string> = POSTERS): string | undefined {
  if (!posters.has(slug)) return undefined;
  return `/posters/${slug}.webp`;
}
